import {evaluatePotentialRuleset, DEFAULT_POTENTIAL_RULESET} from './potentialDSL';

export const PROMOTE_NOW = 'PROMOTE_NOW';
export const PROMOTE_SOON = 'PROMOTE_SOON';
export const KEEP_ROLE = 'KEEP_ROLE';

export const HIGH = 'HIGH';
export const MEDIUM = 'MEDIUM';
export const LOW = 'LOW';

/**
 * Maps the Jacques future potential curve to a potential category.
 * The mapping logic is driven by a client-configurable ruleset (see potentialDSL.js).
 *
 * @param {string} nivelPotCurva - Peak level on the curve (e.g. "4B")
 * @param {number} curva         - Curve index from getPotentialTalentArray
 * @param {Object} [ruleset]     - Client ruleset from the database; falls back to the default
 * @returns {string} HIGH | MEDIUM | LOW
 */
export function getFuturePotentialCategory(nivelPotCurva, curva, ruleset = DEFAULT_POTENTIAL_RULESET) {
    return evaluatePotentialRuleset(ruleset, nivelPotCurva, curva);
}

/**
 * Returns the potential category for a person relative to their position's required level.
 * @param {Object} position - Position with level_match and sublevel_match fields
 * @param {*} level - Person's current level
 * @param {string} sublevel - Person's current sublevel
 * @returns {string} PROMOTE_NOW | PROMOTE_SOON | KEEP_ROLE
 */
/**
 * Projects level/sublevel forward in time using a Jacques progression curve.
 * @param {number} level - Current level
 * @param {string} sublevel - Current sublevel
 * @param {number} slideAge - Number of years to project forward
 * @param {number} potentialAge - Current age + slideAge
 * @param {Array} progresionJacques - Array of {age, nivel, subnivel} transition points
 * @returns {{level: number, sublevel: string}}
 */
export function projectLevelByAge(level, sublevel, slideAge, potentialAge, progresionJacques, edadRangoActual) {
    if (progresionJacques.length === 0)
        return {level, sublevel, edadInicioRango: edadRangoActual, edadFinRango: potentialAge};

    if (slideAge <= 0 || potentialAge < progresionJacques[0].age)
        return {level, sublevel, edadInicioRango: edadRangoActual, edadFinRango: progresionJacques[0].age};

    for (let j = 0; j < progresionJacques.length; j++) {
        const pj = progresionJacques[j];
        if (potentialAge >= pj.age && (j === progresionJacques.length - 1 || potentialAge < progresionJacques[j + 1].age)) {
            const edadInicioRango = pj.age;
            const edadFinRango = (j === progresionJacques.length - 1 || progresionJacques.length === 1) ? 65 : progresionJacques[j + 1].age;
            return {level: pj.nivel, sublevel: pj.subnivel, edadInicioRango, edadFinRango};
        }
    }
    return {level, sublevel, edadInicioRango: edadRangoActual, edadFinRango: potentialAge};
}

export function getPositionMatch(position, level, sublevel) {
    const level_match = position.level_match;
    const sublevel_match_array = position.sublevel_match.split('').reverse();
    const sublevel_comparar = sublevel_match_array.slice(-1);

    if (level === level_match) {
        if (sublevel_match_array.includes(sublevel))
            return PROMOTE_SOON;
        else if (sublevel < sublevel_comparar)
            return PROMOTE_NOW;
        else
            return KEEP_ROLE;
    } else if (level > level_match)
        return PROMOTE_NOW;
    else
        return KEEP_ROLE;
}
